import type { TypographyProps } from '@mui/material';

export type RichTextHeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

/**
 * Heading scale for rich text article bodies, stepping down from the 32px
 * article title (`BlogArticleHeader`) to 16px body copy.
 *
 * Sizes come from the Leafio blog design. The theme's own `h1`-`h6` are a
 * display scale (64-24px) for hero banners and page titles, so they are
 * deliberately not used here — `variant="h2"` would render at 60px.
 */
export const richTextHeadingStyles: Record<RichTextHeadingLevel, TypographyProps> = {
  h1: { fontSize: '2rem', lineHeight: 1.3, fontWeight: 700, mt: { xs: 5, md: 6 }, mb: 3 }, // 32px, as the title
  h2: { fontSize: '1.75rem', lineHeight: 1.3, fontWeight: 700, mt: { xs: 5, md: 6 }, mb: 3 }, // 28px
  h3: { fontSize: '1.5rem', lineHeight: 1.3, fontWeight: 700, mt: 4, mb: 2 }, // 24px
  h4: { fontSize: '1.25rem', lineHeight: 1.4, fontWeight: 700, mt: 3, mb: 1.5 }, // 20px
  // Not offered by the `blockContent` schema.
  h5: { fontSize: '1rem', lineHeight: 1.5, fontWeight: 700, mt: 3, mb: 1.5 },
  h6: { fontSize: '1rem', lineHeight: 1.5, fontWeight: 700, mt: 3, mb: 1.5 },
};

/** The "Quote" style, which otherwise falls back to an unstyled `<p>`. */
export const richTextBlockquoteStyles: TypographyProps['sx'] = {
  my: 3,
  mx: 0,
  pl: 2.5,
  borderLeft: 4,
  borderColor: 'primary.main',
  fontStyle: 'italic',
};
